<template>
  <div>
    <van-tabbar v-model="active" @change="action" style="width: 100%;">
      <van-tabbar-item to="/" icon="home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item to="/Resource" icon="bag-o">
        在线选课
      </van-tabbar-item>
      <van-tabbar-item to="/integral" icon="gift-o">
        积分商城
      </van-tabbar-item>
      <van-tabbar-item to="/My" icon="friends-o">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
    export default {
        name: "foot",
        data() {
            return {
                active: '0',
            }
        },
        created() {

        },

        methods: {
            action(path) {
                console.log(path)
                this.$router.push({path: path})
            }
        },
        components: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/foot.vue